"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPricingInformationLink = exports.getUpgradeLink = void 0;
const otc_entry_1 = __importDefault(require("@tcc/otc-entry"));
/**
 * Gets an upgrade link which is countryCode base.
 *
 * @param {string} [countryCode='US']
 * @returns {string}
 */
const getUpgradeLink = (countryCode = 'US') => otc_entry_1.default.getOtcUpgradeUrl(countryCode);
exports.getUpgradeLink = getUpgradeLink;
/**
 * Returns pricing link with more information
 *
 * @returns {string}
 */
const getPricingInformationLink = () => 'https://climate.com/pricing/';
exports.getPricingInformationLink = getPricingInformationLink;
